import React from "react";
import { TaskRateSheet } from "~/gql/types";
import { RateSheetsSearch } from "~/visuals/organisms/RateSheets";

const TaskRateSheets: React.FC<{
  rateSheets: TaskRateSheet[];
}> = ({ rateSheets }) => <RateSheetsSearch {...{ rateSheets, type: "Task" }} />;

export default TaskRateSheets;
